import React from 'react'
import { Title } from 'components'
import { useFilter, useList } from 'store'
import Filter from './Filter/Filter'
import styles from './FilterContainer.module.scss'

const FilterContainer = ({
  type,
  customFilters = false,
  showHeader = false,
  className = '',
}) => {
  const { isListLoading } = useList()
  const { clearFilters, updateQueryString } = useFilter()

  const handleClearFilters = () => {
    clearFilters()
    updateQueryString()
  }

  return (
    <div>
      <Filter
        className={className || styles[`wrapper-${type}`]}
        blocked={isListLoading()}
        type={type}
        customFilters={customFilters}
      >
        {showHeader && (
          <header className={styles.header}>
            <Title type="h3" font="small">
              Refinar minha busca
            </Title>
            <button type="button" onClick={handleClearFilters}>
              Limpar filtros
            </button>
          </header>
        )}
      </Filter>
    </div>
  )
}

export default FilterContainer
